import { Quote, QuotesFilters, QuoteUser } from 'src/redux/types/quoteSlice';
import { call } from '../@';

export type GetQuotesDto = {
	orderBy?: string;
	sortOrder?: string;
} & QuotesFilters;

export type GetQuotesResponse = {
	quotes: Quote[];
	users: QuoteUser[];
};

export default async function getQuotes({
	payload,
	signal,
}: {
	payload: GetQuotesDto;
	signal: AbortSignal;
}): Promise<GetQuotesResponse> {
	return await call('getQuotes', payload, { signal });
}
